import React from 'react';

/** @internal */
export var searchIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.8 11C17.8 14.7555 14.7555 17.8 11 17.8C7.24446 17.8 4.2 14.7555 4.2 11C4.2 7.24446 7.24446 4.2 11 4.2C14.7555 4.2 17.8 7.24446 17.8 11ZM16.1376 17.1326C14.7477 18.2982 12.9558 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11C19 13.0305 18.2435 14.8843 16.997 16.295L21.8018 21.0997C22.0361 21.3341 22.0361 21.714 21.8018 21.9483C21.5675 22.1826 21.1876 22.1826 20.9533 21.9483L16.1376 17.1326Z"
}));